<template>
  <div class="image-atom container mx-auto h-full text-center">
    <component
      :is="clickable ? GeneralLink : 'div'"
      v-bind="clickable ? { text: '', link: clickable, _type: 'generalLink' } : {}"
      class="h-full"
    >
      <PtcPicture
        v-if="image?.asset"
        provider="sanity"
        format="webp"
        :src="image.asset._ref"
        :alt="
          AssertThat.warnOnly(() =>
            AssertThat.nonEmptyStringOrDefault(image?.altText, ' ', 'ImageAtom alt text empty')
          )
        "
        :img-attrs="{
          class: {
            'mx-auto p-0 h-full object-cover': true,
            'md:w-auto': !widthAttribute,
          },
          style: { width: widthAttribute },
        }"
        :modifiers="{
          crop: image.crop,
          hotspot: image.hotspot,
        }"
        :loading="loading || 'lazy'"
      />
    </component>

    <span
      v-if="caption"
      :class="{
        'center-title mx-auto mt-2 block text-center text-13px italic leading-6 text-www-color-neutral-medium-dark': true,
      }"
      :style="{ width: widthAttribute, maxWidth: '100%' }"
    >
      <em>{{ caption }}</em>
    </span>
  </div>
</template>

<script setup lang="ts">
import GeneralLink from '~/components/Molecules/HeaderComponents/GeneralLink.vue';
import PtcPicture from '~/components/Atmos/PtcPicture/PtcPicture.vue';
import type { ImageAtom } from '~/sanity/types';
import { sanitizeWidth } from '~/utils/width-util';
import * as AssertThat from '~/utils/AssertThat';

const props = defineProps<ImageAtom & { loading?: 'lazy' | 'eager' }>();
const { width, widthType } = props;
const widthAttribute = sanitizeWidth({ width, widthType });
</script>

<style>
@media (max-width: 767px) {
  .image-atom span {
    max-width: 100%;
  }
}
</style>
